"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HighlightedSegment = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var HighlightedSegment = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  width: 100%;\n  background-color: ", ";\n  padding: 12px 16px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.radius.sm;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryShade;
});
exports.HighlightedSegment = HighlightedSegment;